export const GetHostName = (url: string): string => {
    let result = url ?? '';

    // Remove 'https://' or 'http://' from the start of the URL
    if (url.startsWith('https://')) {
        result = url.substring(8);
    } else if (url.startsWith('http://')) {
        result = url.substring(7);
    }

    // Make sure no path is in the URL
    const pathIndex = result.indexOf('/');
    if (pathIndex !== -1) {
        result = result.substring(0, pathIndex);
    }

    return result;
};

export const GetWithScheme = (url: string): string => {
    let result = url ?? '';

    // Ensure the URL starts with 'https://'
    if (!result.startsWith('https://')) {
        result = `https://${result}`;
    }

    return result;
};
